var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../api/axios";
import settings from "../../../appsettings.json";
/**
 * Retrieves the host for the GraphQL endpoint based on the environment.
 * - If the environment is 'localhost', it attempts to get the host from the URL query parameters.
 * - If not found in the query parameters, it checks local storage.
 * - If still not found, it uses a default host from settings.
 * - For non-localhost environments, it returns the host from the current window location.
 *
 * @param {EnvironmentDetailsResponse["environment"]} environment - The environment in which the app is running.
 * @returns {string | null} - The host for the GraphQL endpoint.
 */
export const getHostFromURL = (environment) => {
    var _a;
    if (environment === "localhost") {
        // Get the 'host' parameter from the URL query string
        const params = new URLSearchParams(window.location.search);
        const hostParam = params.get("host");
        // Check if there is already a host saved in local storage
        const hasLocalStorageHost = localStorage.getItem("host");
        // If the 'host' parameter exists in the URL and there's no host in local storage, save it to local storage
        if (hostParam && !hasLocalStorageHost) {
            localStorage.setItem("host", hostParam);
        }
        // Return the 'host' parameter if it exists, otherwise return the host from local storage or the default settings
        return hostParam ? hostParam : (_a = localStorage.getItem("host")) !== null && _a !== void 0 ? _a : settings.UrlHost;
    }
    // For non-localhost environments, return the host from the current window location
    return window.location.host;
};
export const fetchEnvironmentDetails = (setState) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axiosPrivate.get("/React/GetAppSettings");
        // Set the state with the response data.
        setState((prev) => (Object.assign(Object.assign({}, prev), { loading: false, data: response.data })));
    }
    catch (error) {
        // Set the state with an error message.
        setState((prev) => (Object.assign(Object.assign({}, prev), { loading: false, data: Object.assign(Object.assign({}, prev.data), { success: false, errorMessage: "Server Error" }) })));
    }
});
